import React, { useState } from 'react'
import MainContainer from '../../layout/MainContainer'
import { Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton } from '@mui/material'
import SearchBar from '../../components/SearchBar'
import { useNavigate } from 'react-router-dom'

import FilterMenu from '../../components/filterMenu'
import SubscriptionTable from './subscriptionTable'
import CustomPagination from '../../components/CustomPagination'


export const ManageSubscription = () => {
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState('');

    return (
        <MainContainer>
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1 className="">
                     
                      Manage Subscription
                    </h1>
                </div>


                <div className="right_s">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search status & membership"
                            />
                        </Box>
                    </div>
                    <Button className='btn btn_primary' onClick={()=> navigate('/manage-subscription/add')}>+ Add Subscription</Button>
                  <FilterMenu />
                </div>
            </div>


        <div className="cards table_cards">
            <SubscriptionTable />
        </div>
        <CustomPagination />

        </MainContainer>
    )
}

export default ManageSubscription;
